module.exports = __webpack_public_path__ + "static/media/bank_gsyh.a4b6040f.png";